// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"SoundToggle_button_wrapper__Oz_6T"};